const PROFILE_INFO_GRID_CLASS_NAME = 'profile-info-grid';

export default PROFILE_INFO_GRID_CLASS_NAME;
